import type {Table as ReactTable} from '@tanstack/react-table';
import type {ReactNode} from 'react';

import InfoState from '../InfoState';

interface TableNotFoundProps<TData> {
  table: ReactTable<TData>;
  text?: string;
  icon?: ReactNode;
  className?: string;
}

const TableNotFound = function <TData>({
  table,
  text,
  icon,
  className,
}: TableNotFoundProps<TData>) {
  const isEmpty = table.getRowModel().rows?.length === 0;

  if (!isEmpty) {
    return null;
  }

  return <InfoState className={className} title={text} icon={icon} />;
};

export default TableNotFound;
